import { BookOpenText, Inbox, Megaphone, SquareTerminal } from "lucide-react"
import type { NavigationItem } from "./types"

/**
 * Navigation configuration for the sidebar menu
 * Contains all navigation items with their routes and translation keys
 */
export const navigationConfig: NavigationItem[] = [
	{
		id: "analytics",
		label: "navigation.analytics",
		icon: SquareTerminal,
		children: [
			{
				id: "key-metrics",
				label: "navigation.key-metrics",
				route: "/key-metrics",
			},
			{
				id: "appointment-confirmation",
				label: "navigation.appointment-confirmation",
				route: "/appointment-confirmation",
			},
			{
				id: "appointment-sources",
				label: "navigation.appointment-sources",
				route: "/appointment-sources",
			},
			{
				id: "widget-stats",
				label: "navigation.widget-stats",
				route: "/widget-stats",
			},
			{
				id: "esia-auth",
				label: "navigation.esia-auth",
				route: "/esia-auth",
			},
			{
				id: "reviews",
				label: "navigation.reviews",
				route: "/reviews",
			},
		],
	},
	{
		id: "journals",
		label: "navigation.journals",
		icon: BookOpenText,
		children: [
			{
				id: "leads",
				label: "navigation.leads",
				icon: Inbox,
				route: "/leads",
			},
		],
	},
	{
		id: "marketing",
		label: "navigation.marketing",
		icon: Megaphone,
		children: [
			{
				id: "marketing-mailings",
				label: "navigation.marketing-mailings",
				route: "/marketing/mailings",
			},
			{
				id: "marketing-exports",
				label: "navigation.marketing-exports",
				route: "/marketing/exports",
			},
			{
				id: "marketing-reporting",
				label: "navigation.marketing-reporting",
				route: "/marketing/reporting",
			},
		],
	},
]

/**
 * Default breadcrumb translation key for root path
 */
export const DEFAULT_BREADCRUMB_KEY = "navigation.dashboard"
